import * as React from "react";
import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Tree, Classes } from "@blueprintjs/core";
import { Button,Switch, Card,H4,Intent, Elevation, Overlay,Icon } from "@blueprintjs/core";
import{HomeProps} from './Home.tsx'
import{CardPdf} from './CardPdf.tsx'
import {CardQuizz} from './CardQuizz.tsx'
import CardCreationEditorForTeacher from "./CardCreationEditorForTeacher.tsx";
//import { Example } from '@blueprintjs/docs-theme';
//import { DialogExample } from './components/dialogExample';
import {
  Alignment,
  H5,
  Navbar,
  Toast,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
  Toaster,
  Position,
  Code,
    MultistepDialog,
    DialogStep,
    ButtonProps,
    RadioGroup,
    Radio,
    NumericInput,
    Label,
} from "@blueprintjs/core";
import PanelNom from './PanelNom.tsx';
import PanelEmail from './PanelEmail.tsx';
import PanelPassword from './PanelPassword.tsx';
import PanelOnePassword from './PanelOnePassword.tsx';
import CardDocument from './CardDocument.tsx';
import CardImage from './CardImage.tsx';
import { type, userInfo } from "os";
import CardDraggable from "./CardDraggable.tsx";
import CardObject from "./CardObject.tsx";
import CardTexte from "./CardTexte.tsx";
import CardDocumentWeb from './CardDocumentWeb.tsx';
import CardEditorViewer from "./CardEditorViewer.tsx";
import { initial } from "lodash";
import CardEditor from "./CardEditor";

const toaster=Toaster.create({
  className: "my-toaster",
  position: Position.TOP_RIGHT
});

export default class CardDocumentsEnseignants extends React.Component  <HomeProps> {
 
  constructor(props) {
        super(props);
        //this.setState({title_lesson:this.props.title_lesson})
       // this.setState({lesson_description:this.props.lesson_description})
       // this.handleChange = this.handleChange.bind(this);
      }
      state = {
        name: '',
        coloropen:"#ffffff",
        force_width:320,
        isDocOpen:'none',
        isOpenEdit:false,
        isOpenDelete:false,
        title_lesson:this.props.title_lesson,
        lesson_description:this.props.lesson_description,
        mustchange:false,
        id_cours:this.props.id_cours,
        status_published:"eye-off",
        is_upload:false,
        is_inputurl:false,
        is_inputpdf:false,
        is_inputimage:false,
        is_inputquizz:false,
        is_inputmedia:false,
        is_inputother:false,
        is_inputjsontexte:false,
        is_iframe:'false',
        type_document_creation:'',
        openAddDocument:false,
        istypeaudio:'false',
        openCreationDocument:false,
        title_document_creation:'',
        description_document_creation:'',
        objectif_document_creation:'',
        url_saisie:'',
        edit_published:false,
        datadocuments:[],
        droitpublication:[],
        dataclassesetudiants:[],
        datacours:[],
        timestamp:0,
        editorsaved:false,
        must_refresh:false,
        audiolingua:false,
        helpressourcesweb:false
      }  
  componentDidMount () { 
   
    if(this.props.config=='true')this.setState({force_width:480});
    window.addEventListener("message", this.handlerMessageiframe);
    this.init_publication();
    //if(this.state.id_cours!="")this.LoadDataDocuments(this.state.id_cours);
    
    //this.setState({title_lesson:this.props.title_lesson})
    //this.setState({lesson_description:this.props.lesson_description})
    
  }
init_publication=()=>{
  var droitpublication=[];
    var tab=this.props.publication.split("_");
    var obj2=[];
    
    var ee=false;
    tab.map((itemidclasse)=>{if(itemidclasse=="0")ee=true;});
    if(ee)obj2.push({nom:"Tout le monde",selected:true,ID:0,id_cours:this.props.id_cours});
    else obj2.push({nom:"Tout le monde",selected:false,ID:0,id_cours:this.props.id_cours});
    tab.map((itemidclasse)=>
    {
      if(itemidclasse!="")
      {
      this.props.dataclassesetudiants.map((item)=>{
        if(item.ID==itemidclasse){
          var itt=item;
          itt.selected=true;
          obj2.push(item);
        }
       })
      }
     });
    obj2.map((it3)=>it3.id_cours=this.props.id_cours);
    localStorage.setItem('droitpublication'+this.props.id_cours, JSON.stringify({ droitpublication: obj2 }));
    droitpublication = JSON.parse(localStorage.getItem('droitpublication'+this.props.id_cours));
    var publier=0;
    if(droitpublication==null){droitpublication=[]}
    else droitpublication=droitpublication.droitpublication;
    droitpublication.map((it)=>{if (it.selected)publier++;});
    if(publier>0)this.setState({status_published:'eye-open'});
    else this.setState({status_published:'eye-off'});
}
LoadDataDocuments=(ev)=>
{
  
  console.log(ev);
  console.log(ev.target.id);
  var id=ev.target.parentElement.id;
  //si on clique pas sur le span mais sur le bouton
  if(id==undefined)id=ev.target.id;
  if(id=='')id=ev.target.id;
  this.LoadDataDocumentsDirect(id);
}
handleEditorsaved=(value,url="")=>{this.setState({editorsaved:value});this.setState({url_saisie:url})}
LoadDataDocumentsDirect=(id)=>{
  if (id==-1)id=this.state.id_cours;
  var that=this;
  var xhr = new XMLHttpRequest();
  xhr.overrideMimeType("application/json");
  
  //var that=_this;
  xhr.open('GET','/api/public/getdocuments?id_cours='+ id); //this.state.navbarTabId)
  
  xhr.setRequestHeader("Content-Type", "application/json");

  //send the form data
  xhr.send();

  xhr.onreadystatechange = function() {
      if (xhr.readyState == XMLHttpRequest.DONE) {
                    
        if(xhr.status==200) 
        { 
        
        //console.log(xhr.responseText);
        var jsonResponse = JSON.parse(xhr.responseText);
        //console.log(jsonResponse);
        var obj=[];
        jsonResponse.sort((a,b)=>{if(a.type < b.type) return -1;
          if(a.type> b.type) return 1;
          return 0;}).map((itc)=>{obj.push(itc);});
        that.setState({datadocuments:obj});
        //setData(jsonResponse);
          //toaster.show( {message:"Matière "+ uMatiere.matiere + " créée"});
         
        }
        if(xhr.status==404) {console.log( {message:"erreur"}); }
        if(xhr.status==500) {console.log( {message:"erreur"}); }
        
      
      }
      
  }
}
  loaddocument(ev)
  {
    //console.log(ev.target.id);
    var id=ev.target.parentElement.id;
    //si on clique pas sur le span mais sur le bouton
    if(id==undefined)id=ev.target.id;
    if(id=='')id=ev.target.id;
    //console.log(id);
    var doc=[{}];
    //if(id==4) doc=[{type:"image",url:"/upload/media/08.jpg",title:"Test document image",objectif:"",description:"Document sur le serveur dans media hauteur supèrieure à largeur",id:"1"},{type:"audio",url:"https://www.teamparty.fr/test/sultanofswing.mp3"}]
    //if(id==3) doc=[{type:"image",url:"/upload/media/09.jpg",title:"Albert Einstein",objectif:"",description:"Photo d'Albert Einstein",id:"1"},{type:"pdf",url:"/upload/media/relativite.pdf",title:"La relativité restreinte",objectif:"Introduction",description:"Introduction à la relativité restreinte",id:"1"}]
    //if(id==20) doc=[{type:"yt",url:"https://www.youtube.com/watch?v=a_X8U11XBiA",objectif:"Dans ce cours vous allez apprendre le génétif entre le possesseur et possédé. ",title:"Anglais Génétif",description:"Apprendre le Génétif.",id:"1"},{type:"quizz"}]
    this.setState({datadocuments:doc});
  }
  sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  }
 handlerMessageiframe = event => 
 {
    if(this.state.is_upload==false)return;
    console.log("from carddocumentsenseignants:"+event);
    if(event.data.payload!=undefined)return;
    const data = JSON.parse(event.data)
    if(data.message=="uploaded")
    {
      if(data.files.length>1)
      {
        var num=0;
        data.files.forEach((item)=>{
          //var filename=item.filename;
          num++;
          this.setState({title_document_creation:'Document '+num});
          this.setState({istypeaudio:'false'});
          if(item.typedufichier=='office')item.typedufichier='object'
          this.setState({type_document_creation:item.typedufichier})
          if((item.typedufichier=="audio")||(item.typedufichier=="video"))
          {
            this.setState({is_inputmedia:true});
            this.setState({url_saisie:item.filename});
          }
          if((item.typedufichier=="pdf"))
          {
            this.setState({is_inputpdf:true});
            this.setState({url_saisie:item.filename});
          }
          if((item.typedufichier=="image"))
          {
            this.setState({is_inputimage:true});
            this.setState({url_saisie:item.filename});
          }
          if((item.typedufichier=="object"))
          {
            this.setState({is_inputother:true});
            this.setState({url_saisie:item.filename});
          }
          if((item.typedufichier=="text"))
          {
            this.setState({is_inputother:true});
            this.setState({url_saisie:item.filename});
          }
          if(item.typedufichier=="audio")this.setState({istypeaudio:'true'});
          this.AjouterDocumentAsync();
          this.setState({is_upload:false});
          this.setState({openCreationDocument:false});
          toaster.show( {icon:'document', intent:Intent.SUCCESS,timeout:5000,message:"Le fichier "+item.filename+" est téléversé. Taille du fichier:"+item.size/(1024*1024)+"Mo"});
        });
        this.setState({isOpen:false});
      }
      else
      {
          var filename=data.filename;
          this.setState({istypeaudio:'false'});
          this.setState({type_document_creation:data.type})
          if((data.type=="audio")||(data.type=="video"))
          {
            this.setState({is_inputmedia:true});
            this.setState({url_saisie:data.filename});
          }
          if((data.type=="pdf"))
          {
            this.setState({is_inputpdf:true});
            this.setState({url_saisie:data.filename});
          }
          if((data.type=="image"))
          {
            this.setState({is_inputimage:true});
            this.setState({url_saisie:data.filename});
          }
          if((data.type=="object"))
          {
            this.setState({is_inputother:true});
            this.setState({url_saisie:data.filename});
          }
          if((data.type=="text"))
          {
            this.setState({is_inputother:true});
            this.setState({url_saisie:data.filename});
          }
          if(data.type=="audio")this.setState({istypeaudio:'true'});
          this.setState({is_upload:false});
          this.setState({openCreationDocument:true});
          toaster.show( {icon:'document', intent:Intent.SUCCESS,timeout:5000,message:"Le fichier "+data.filename+" est téléversé. Taille du fichier:"+data.size/(1024*1024)+"Mo"})
      }
        
    }
    console.log("message from iframe depuis cours id:"+this.props.id_cours, data)
  }
  componentDidUpdate(prevProps, prevState) {
    if(this.props.dataclassesetudiants!=this.state.dataclassesetudiants)
    {
      this.setState({dataclassesetudiants:this.props.dataclassesetudiants});
      this.init_publication();
      
    }
    if(this.props.datacours!=this.state.datacours)
    {
      this.setState({datacours:this.props.datacours});
      this.init_publication();
      
    }
    if(this.state.mustchange==false)
    {
      if(this.state.title_lesson!=this.props.title_lesson)this.setState({title_lesson:this.props.title_lesson})
      if(this.state.lesson_description!=this.props.lesson_description)this.setState({lesson_description:this.props.lesson_description})
    }
    else
    {
      this.props.title_lesson=this.state.title_lesson;
      this.props.lesson_description=this.state.lesson_description;
      this.setState({mustchange:false})
    }
    if(this.state.must_refresh)this.setState({must_refresh:false});
    //this.setState({lesson_description:this.props.lesson_description})
  }
  componentWillUnmount(): void {
     window.removeEventListener("message", this.handlerMessageiframe)
  }
  handle_published=()=>
  {
    console.log("handle_published");
    console.log("cours:"+this.props.id_cours);
    var droitpublication=[];
    droitpublication = JSON.parse(localStorage.getItem('droitpublication'+this.props.id_cours));
    var obj=[];
    if(droitpublication==null){droitpublication=[];obj.push({nom:"Tout le monde",selected:false,ID:0,id_cours:this.props.id_cours});}
    else droitpublication=droitpublication.droitpublication;
    droitpublication.map((it)=>{if (it.ID==0){obj.push(it);}});
      
      this.props.dataclassesetudiants.map((item)=>{
        var exist=false;
        droitpublication.map((it)=>{if (it.ID==item.ID){obj.push(it);exist=true;}});
        //item.id_cours=this.props.id_cours;
        if(!exist)
        {
          var itt=item;
          itt.selected=false;
          obj.push(item);
        }
      })
      obj.map((it3)=>it3.id_cours=this.props.id_cours);
      this.setState({droitpublication:obj});
    droitpublication.map((it)=>{console.log(it.nom+":"+it.id_cours+":"+it.selected);});
    this.setState({must_refresh:true});
    this.setState({edit_published:true});
    
    return;
    if(this.state.status_published=='eye-off'){
      this.setState({status_published:'eye-open'});
      toaster.show( {icon:'eye-open', intent:Intent.SUCCESS,timeout:2000,message:"Le cours est disponible en ligne"});
    }else{
      this.setState({status_published:'eye-off'});
      toaster.show( {icon:'eye-off', intent:Intent.DANGER,timeout:2000,message:"Le cours n'est plus disponible en ligne"});
    }
  }
  
  AjouterDocumentAsync=async ()=>{
    this.AjouterDocument();
    await this.sleep(2000);
  }
  AjouterDocument=()=>{
    
    var xhr = new XMLHttpRequest();
        xhr.overrideMimeType("application/json");
        /*
        gorm.Model
        Id_cours    int    `json:"id_cours"`
        Url         string `json:"url"`
        Title       string `json:"title"`
        Objectif    string `json:"objectif"`
        Description string `json:"description"`
        Publication string `json:"publication"`
        Type        string `json:"type"`
        Tag         string `json:"tag"
        */
       var that=this;
        var formData = new FormData();
        console.log("this.props.id_cours");
        console.log(this.props.id_cours);
        formData.append('id_cours', this.props.id_cours);
        formData.append('url', this.state.url_saisie);
        formData.append('title', this.state.title_document_creation);
        formData.append('objectif', this.state.objectif_document_creation);
        formData.append('description', this.state.description_document_creation);
        formData.append('publication',"");
        formData.append('type',this.state.type_document_creation);
        formData.append('tag', this.props.id_cours);
        
             
        xhr.open('POST','/api/public/createdocument')
        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.send(JSON.stringify(Object.fromEntries(formData)));

        xhr.onreadystatechange = function() {
            if (xhr.readyState == XMLHttpRequest.DONE) {
             if(xhr.status==200) {that.LoadDataDocumentsDirect(that.props.id_cours);toaster.show( {icon:'document-open', intent:Intent.SUCCESS,timeout:2000,message:"Le document "+that.state.title_document_creation+" est ajouté"});that.setState({openCreationDocument:false});}
             if(xhr.status==500) {toaster.show( {icon:'document-open', intent:Intent.DANGER,timeout:3000,message:"erreur document non créé"}); }
             //setUserPassword({})
            
            }
           
        }
  }
  renderItem = (p) => {
   // console.log(p.type)
    if(p.type==undefined){return (
      <div></div>
      );
    }
    if (p.type=="image") {
      return (
        <CardImage   {...this.props} type={p.type} LoadDataDocumentsDirect={this.LoadDataDocumentsDirect} id_document={p.ID} handleEdition={this.handleEdition} id={p.ID} url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="yt" ) {
      return (  
        <CardDocument {...this.props} type={p.type} LoadDataDocumentsDirect={this.LoadDataDocumentsDirect} id_document={p.ID} handleEdition={this.handleEdition} id={p.ID} url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="video" ) {
      return (  
        <CardDocument {...this.props} type={p.type} LoadDataDocumentsDirect={this.LoadDataDocumentsDirect} id_document={p.ID} handleEdition={this.handleEdition} id={p.ID} url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="quizz" ) {
      return (  
        <CardQuizz    {...this.props } type={p.type} LoadDataDocumentsDirect={this.LoadDataDocumentsDirect} id_document={p.ID}handleEdition={this.handleEdition} id={p.ID} url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="pdf" ) {
      return (  
        
        <CardDocument {...this.props} id_document={p.ID} type={p.type} LoadDataDocumentsDirect={this.LoadDataDocumentsDirect} handleEdition={this.handleEdition} id={p.ID} youtube_frame='true' url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="jsontexte" ) {
      return (  
        <CardEditorViewer      {...this.props} LoadDataDocumentsDirect={this.LoadDataDocumentsDirect} handleEdition={this.handleEdition} id={p.ID} id_document={p.ID} url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="audio" ) {
      return (  
        <CardDocument {...this.props} id_document={p.ID} type={p.type} LoadDataDocumentsDirect={this.LoadDataDocumentsDirect} handleEdition={this.handleEdition} id={p.ID} type_audio="true" url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="object" ) {
      return (  
        <CardObject {...this.props} id_document={p.ID}  type={p.type}LoadDataDocumentsDirect={this.LoadDataDocumentsDirect} handleEdition={this.handleEdition} id={p.ID}  url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="text" ) {
      return (  
        /*<CardDocument {...this.props} id_document={p.ID} type={p.type} LoadDataDocumentsDirect={this.LoadDataDocumentsDirect} handleEdition={this.handleEdition} id={p.ID} youtube_frame='true' url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>*/
        <CardObject {...this.props} id_document={p.ID}  type={p.type}LoadDataDocumentsDirect={this.LoadDataDocumentsDirect} handleEdition={this.handleEdition} id={p.ID}  url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    if (p.type =="web" ) {
      return (  
        <CardDocumentWeb {...this.props} id_document={p.ID} type={p.type} LoadDataDocumentsDirect={this.LoadDataDocumentsDirect} handleEdition={this.handleEdition} id={p.ID} youtube_frame='true' url_video={p.url} objectif={p.objectif} title_document={p.title} description={p.description}/>
      );
    }
    
    return (
        <div></div>
    );
}
handleEdition=(modif)=>
{
  //console.log(modif);
  if(modif==null) return
  if(modif.update!=undefined)
  {
    console.log("udpdate document" + modif.id)
    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");
    var formData = new FormData();
    formData.append('Model.ID', modif.id);
    formData.append('title', modif.title);
    formData.append('objectif', modif.objectif);
    formData.append('description', modif.description);
    formData.append('tag', modif.id);

    xhr.open('POST','/api/public/updatedocument')
    
    xhr.setRequestHeader("Content-Type", "application/json");

    //send the form data
    xhr.send(JSON.stringify(Object.fromEntries(formData)));

          xhr.onreadystatechange = function() {
              if (xhr.readyState == XMLHttpRequest.DONE) {
                            
              if(xhr.status==200) 
              { 
              
                console.log(xhr.responseText);
                toaster.show( {icon:'document-open', intent:Intent.SUCCESS,timeout:2000,message:"Le document est mis à jour"});
                return;
                var jsonResponse = JSON.parse(xhr.responseText);
                console.log(jsonResponse);
                
                
                
              }
              if(xhr.status==404) {console.log( {message:"erreur"}); }
              if(xhr.status==500) {console.log( {message:"erreur"}); }
              
              }
            
          }
    return;
  }
  this.state.datadocuments.map(p => {
   
    if(p.ID==modif.id)
    {
      console.log(p);
      p.title=modif.title;
      p.description=modif.description;
      p.objectif=modif.objectif;
    }
  });
  this.setState({datadocuments:this.state.datadocuments});
}
ChangeType=(ltype)=>
{
  this.setState({type_document_creation:ltype});
  
  if(ltype=='video'){
    this.setState({is_inputmedia:true});
    this.setState({is_inputimage:false});
    this.setState({is_iframe:'false'});
    this.setState({istypeaudio:'false'});
    this.setState({is_inputpdf:false});
    this.setState({is_inputother:false});
  }
  else
  if(ltype=='audio'){
    this.setState({is_inputmedia:true});
    this.setState({is_inputimage:false});
    this.setState({is_iframe:'false'});
    this.setState({istypeaudio:'true'});
    this.setState({is_inputpdf:false});
    this.setState({is_inputother:false});
  }
  else
  if(ltype=='image'){
    this.setState({is_inputmedia:false});
    this.setState({is_inputimage:true});
    this.setState({is_iframe:'false'});
    this.setState({istypeaudio:'false'});
    this.setState({is_inputpdf:false});
    this.setState({is_inputother:false});
  }
  else
  if(ltype=='web'){
    this.setState({is_inputmedia:true});
    this.setState({is_inputimage:false});
    this.setState({is_iframe:'true'});
    this.setState({istypeaudio:'false'});
    this.setState({is_inputpdf:false});
    this.setState({is_inputother:false});
  }
  else
  if(ltype=='pdf'){
    this.setState({is_inputmedia:false});
    this.setState({is_inputimage:false});
    this.setState({is_inputpdf:true});
    this.setState({is_inputother:false});
    
  }else
  if(ltype=='object'){
    this.setState({is_inputmedia:false});
    this.setState({is_inputimage:false});
    this.setState({is_inputpdf:false});
    this.setState({is_inputother:true});
  }
  else
  if(ltype=='text'){
    this.setState({is_inputmedia:false});
    this.setState({is_inputimage:false});
    this.setState({is_inputpdf:false});
    this.setState({is_inputother:true});
  }
   this.setState({url_saisie:this.state.url_saisie});
}
handlePublicChange=(itemclasse)=>
{
  //var itemclasse=itemclassetab[0];
  //console.log("id_cours:"+itemclasse.id_cours);
  //this.state.droitpublication.map((it)=>{console.log(it.id_cours);});
  var b=this.getcheckPublication(itemclasse.ID)  
  if(itemclasse.ID==0){
      this.state.droitpublication.map((it)=>it.selected=!b);
    }
    else
    {
      this.state.droitpublication.filter((it)=>it.ID==itemclasse.ID).map((it2)=>{if(it2.id_cours==this.props.id_cours)it2.selected=!b});
      if (b)this.state.droitpublication.filter((it)=>it.ID==0).map((it2)=>{if(it2.id_cours==this.props.id_cours)it2.selected=!b});
    }
   // console.log(itemclasse);
   var obj=[];
   var publier=0;
   this.state.droitpublication.map((it)=>{obj.push(it);if(it.selected)publier++;});
   this.setState({droitpublication:obj});
   localStorage.setItem('droitpublication'+this.props.id_cours, JSON.stringify({ droitpublication: obj }));
   if(publier>0)this.setState({status_published:'eye-open'});
   else this.setState({status_published:'eye-off'});
   this.setState({must_refresh:true});
}
getcheckPublication=(id)=>
{
  var b=false;
  this.state.droitpublication.filter((it)=>it.ID==id).map((it)=>b=it.selected);
  return b;
}
getNomPublication=(id)=>
{
  var nn="";
  this.state.droitpublication.filter((it)=>it.ID==id).map((it)=>nn=it.nom);
  return nn;
}
  //Test One drive iframe pas possible car document s'ouvre dans une autre fenêtre
 // {id_documents == 5 ?<CardDocument {...this.props} url_video="https://onedrive.live.com/embed?cid=CCE819EC89F4DDE9&resid=CCE819EC89F4DDE9%21332163&authkey=AC59_u58GzB75Yg" objectif="Document sur One Drive" title_document="Test" description="Test"/>:<div></div>}
 //<iframe src="https://onedrive.live.com/embed?cid=CCE819EC89F4DDE9&resid=CCE819EC89F4DDE9%21332163&authkey=AC59_u58GzB75Yg" width="98" height="120" frameborder="0" scrolling="no"></iframe>
   render() {
    
    
    const {config,type_audio,id_documents,youtube_frame,lesson_description,title_lesson,url_video,title_document,description,objectif,isnotdocument,handleEdition,navFiles,state,isnotconnected,menuVisibility,isOpenSign,usernickname,isOpenLogin,handleOpenVisio,handleOpen,handleClose,handleChange,handleSendCnx,handleSelectionChange,handlhandleSelectionGetLogineSelectionChangeLogin,handleOpenLogin,handleCloseLogin,handleChangeLogin,handleSendCnxLogin}=this.props;
  
    return(
      <div style={{display: this.props.coursopen && this.state.isDocOpen=='none'?'none':isnotdocument,marginLeft:this.state.isDocOpen=='none'?0:-200}}>
      <Card style={{display:'block',width:this.state.force_width,margin:4,backgroundColor:this.state.coloropen}}><H4>{this.state.title_lesson}</H4><p><a>{this.state.lesson_description}</a></p>
      {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenEdit:true});}} className={Classes.OUTLINED +" "+ Classes.LARGE} icon="edit" title="Editer" />:<div></div>}
      {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:true});}} className={Classes.OUTLINED+" "+ Classes.INTENT_DANGER +" " + Classes.LARGE} icon="trash" title="Effacer" />:<div></div>}
      {this.props.toolbar=='true'?<Button className={Classes.OUTLINED+" "+ Classes.LARGE} icon="cube-add" title="Ajouter un document" onClick={(ev)=>{ev.preventDefault();this.setState({openAddDocument:true});}}/>:<div></div>}
      {this.props.toolbar=='true'?<Button className={Classes.OUTLINED+" "+ Classes.LARGE +" "+ Classes.INTENT_WARNING} icon={this.state.status_published} title="Cours en ligne" onClick={(ev)=>{ev.preventDefault();this.handle_published();}}/>:<div></div>}
      {this.props.toolbar=='true'?<Button id={this.props.id_cours} style={{display: 'block',marginTop:15}} onClick={(ev)=>{ev.preventDefault();if(this.state.isDocOpen=='none'){this.setState({isDocOpen:'flex'});this.LoadDataDocuments(ev);this.setState({coloropen:'#b6e3ff'});this.props.handlestate(this.state.isDocOpen=='none');}else{this.setState({isDocOpen:'none'});this.props.handlestate(this.state.isDocOpen=='none');this.setState({coloropen:'#ffffff'})}}} >{this.state.isDocOpen=='none'?'Ouvrir':'Fermer'}</Button>:<div></div>}
      <Overlay isOpen={this.state.openAddDocument} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
      
      <div style={{ color: '#444', background: '#fff', padding: '40px', width: '70%',maxWidth: 800,margin: '1% 15%'}}>
      {this.state.openCreationDocument ?<Card>
        <H4>Ajout d'un document</H4>
        <div style={{marginTop:5}}><span>Titre</span><input onChange={(ev)=>{this.setState({title_document_creation:ev.target.value})}} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir le titre de votre document"/></div>
        <div style={{marginTop:5}}><span>Description</span><input onChange={(ev)=>{this.setState({description_document_creation:ev.target.value})}} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir une description votre document"/></div>
        <div style={{marginTop:5}}><span>Objectif</span><input onChange={(ev)=>{this.setState({objectif_document_creation:ev.target.value})}} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir un objectif ou une consigne"/></div>
        <div style={{marginTop:10}}>
          <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({is_inputurl:false});this.setState({is_inputmedia:false});this.setState({is_inputpdf:false});this.setState({is_inputother:false});this.setState({is_inputquizz:false});this.setState({is_inputimage:false});this.setState({openCreationDocument:false});this.setState({is_inputjsontexte:false});this.handleEditorsaved(false);}}>Annuler</Button>
          <Button disabled={this.state.editorsaved} style={{marginLeft:5}} intent={Intent.SUCCESS} onClick={(ev)=>{ev.preventDefault();this.setState({is_inputurl:false});this.setState({is_inputmedia:false});this.setState({is_inputpdf:false});this.setState({is_inputother:false});this.setState({is_inputquizz:false});this.setState({is_inputimage:false});this.setState({is_inputjsontexte:false});this.AjouterDocument()}}>Ajouter le document</Button>
        </div>
        </Card>:<div></div>
        }
        {this.state.is_upload ? <iframe style={{width:'100%',height:'530px'}} src='upload/index.html'></iframe>:<div></div>}
        {this.state.is_inputjsontexte ? <CardCreationEditorForTeacher handleEditorsaved ={this.handleEditorsaved} _onUploadtext={this.props._onUploadtext} timestamp={this.state.timestamp}  userid={this.props.userid} recordingsbydate={[]} matiere_id={this.props.matiere_id} id_document={undefined} title_document={this.state.title_document_creation}/>:null}
        {this.state.is_inputurl ? <div><div style={{margin:"20px 0 0"}}><span> <H4>Type de documents</H4></span></div><Button onClick={(ev)=>{ev.preventDefault();this.ChangeType('video');}} icon="video" >Video</Button><Button icon="video" onClick={(ev)=>{ev.preventDefault();this.ChangeType('audio');}}>Audio</Button><Button icon="shapes" onClick={(ev)=>{ev.preventDefault();this.ChangeType('image');}} >Image</Button><Button icon="link" onClick={(ev)=>{ev.preventDefault();this.ChangeType('web');}} >Page Internet</Button><Button icon="manual" onClick={(ev)=>{ev.preventDefault();this.ChangeType('pdf');}}>PDF</Button><Button icon="document" onClick={(ev)=>{ev.preventDefault();this.ChangeType('object');}}>Autres documents</Button><div style={{margin:"20px 0 0"}}><span><H4>Adresse Internet du média</H4></span></div><input style={{width: '100%',padding: 10,fontWeight: 600}} onChange={(ev)=>{this.setState({url_saisie:ev.target.value})}} placeholder ="Saisir l'adresse url du document"/></div>:<div></div>}
        {this.state.is_inputmedia ? <CardDocument youtube_frame={this.state.is_iframe} type_audio={this.state.istypeaudio} title_document={this.state.title_document_creation} description={this.state.description_document_creation} objectif={this.state.objectif_document_creation} style={{width: '100%'}} url_video={this.state.url_saisie}></CardDocument>:<div></div>}
        {this.state.is_inputpdf ? <CardPdf title_document={this.state.title_document_creation} description={this.state.description_document_creation} objectif={this.state.objectif_document_creation}  url_video={this.state.url_saisie}></CardPdf>:<div></div>}
        {this.state.is_inputimage ? <CardImage title_document={this.state.title_document_creation} description={this.state.description_document_creation} objectif={this.state.objectif_document_creation}  url_video={this.state.url_saisie}></CardImage>:<div></div>}
        {this.state.is_inputother ? <CardObject title_document={this.state.title_document_creation} description={this.state.description_document_creation} objectif={this.state.objectif_document_creation}  url_video={this.state.url_saisie}></CardObject>:<div></div>}
        {this.state.is_inputquizz ? <CardQuizz title_document={this.state.title_document_creation} description={this.state.description_document_creation} objectif={this.state.objectif_document_creation}  url_video={this.state.url_saisie}></CardQuizz>:<div></div>}
        {!this.state.openCreationDocument ?<div> <H4>Ajouter un document dans votre cours</H4>
        <p style={{marginTop:20}}>
              Vous pouvez utiliser un document du web en entrant l'adresse internet où se trouve ce document (Url),
              ou bien déposer en ligne sur le serveur LabTice un document depuis votre ordinateur ou votre tablette.
        </p>
        <p style={{marginTop:20}}><Icon icon="info-sign"></Icon><a onClick={(ev)=>{this.setState({helpressourcesweb:!this.state.helpressourcesweb});}}>Ressources sur le Web</a></p>
              <div style={{display:this.state.helpressourcesweb?'block':'none'}}>
                <Card><H5><a onClick={(ev)=>{this.setState({audiolingua:!this.state.audiolingua});}}>Audio Lingua</a></H5>
                <div style={{display:this.state.audiolingua?'block':'none'}}>
                <p>
                Le site Audio Lingua propose à ce jour plus de 7350 fichiers son dans 14 langues.<br/>
                Il s’agit de documents authentiques, d’enregistrements de locuteurs natifs.<br/>
                Le site Audio Lingua est utilisé dans plus de 160 pays par presque 200 000 utilisateurs par mois en moyenne.<br/>
                Rappelons que la plate-forme vous met ces fichiers gratuitement à disposition et qu’ils sont libres de droits<br/>
                pour une utilisation en classe, en baladodiffusion et pour l’intégration dans vos séquences et même vos blogs, ENT ou site
                </p>
                <p>
                  Télécharger le podcast choisi (ou faire clique droit et enregistrer le lien sous sur le bouton télécharger du podcast)<br/>
                  et venez le glisser en choisisant le bouton "Déposer un document depuis mon ordinateur" 
                </p>
                <a href="https://www.audio-lingua.eu/" target="_blank">Accéder au site Audio Lingua</a>
                </div>
              </Card>
              </div>
        
                                
          <br />
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({is_upload:false});this.setState({helpressourcesweb:false});this.setState({is_inputurl:false});this.setState({is_inputmedia:false});this.setState({is_inputother:false});this.setState({is_inputpdf:false});this.setState({is_inputquizz:false});this.setState({is_inputimage:false});this.setState({openAddDocument:false});}}>Fermer</Button>
          <Button intent={Intent.SUCCESS} onClick={(ev)=>{
            ev.preventDefault();this.setState({is_upload:true});this.setState({helpressourcesweb:false});this.setState({title_document_creation:''});this.setState({objectif_document_creation:''});this.setState({description_document_creation:''});this.setState({is_inputmedia:false});this.setState({is_inputurl:false});this.setState({is_inputother:false});this.setState({is_inputpdf:false});this.setState({is_inputquizz:false});this.setState({is_inputimage:false});
            }} style={{ margin: "" }}>
              Déposer un document en ligne depuis mon ordinateur
          </Button>
          <Button intent={Intent.SUCCESS} onClick={(ev)=>{
            ev.preventDefault();
            this.setState({is_upload:false});
            this.setState({title_document_creation:''});
            this.setState({objectif_document_creation:''});
            this.setState({description_document_creation:''});
            this.setState({is_inputurl:true});
            this.setState({is_inputmedia:true});
            this.setState({is_inputpdf:false});this.setState({helpressourcesweb:false});this.setState({is_inputother:false});this.setState({is_inputquizz:false});this.setState({is_inputimage:false});
            this.setState({openCreationDocument:true});
            this.setState({type_document_creation:'video'});
            }} style={{ margin: "" }}>
              Ajouter un document qui est déjà sur le Web
          </Button>
          <Button icon="edit" intent={Intent.SUCCESS} onClick={(ev)=>{
            ev.preventDefault();
            this.setState({is_upload:false});
            this.setState({title_document_creation:''});
            this.setState({objectif_document_creation:''});
            this.setState({description_document_creation:''});
            this.setState({is_inputurl:false});
            this.setState({is_inputmedia:false});
            this.setState({is_inputpdf:false});this.setState({is_inputother:false});this.setState({is_inputquizz:false});this.setState({is_inputimage:false});
            this.setState({openCreationDocument:true});
            this.setState({is_inputjsontexte:true});
            this.handleEditorsaved(true);
            this.setState({helpressourcesweb:false});
            this.setState({timestamp:new Date().getTime()});
            
            this.setState({type_document_creation:'jsontexte'});
            }} style={{ margin: "" }}>
              Créer un document texte
          </Button>
        </div></div>:<div></div>}
        
      </div>
      </Overlay>

      <Overlay isOpen={this.state.isOpenDelete} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H4>Effacer le cours {this.state.title_lesson}</H4>
                       
                        <p style={{marginTop:20}}>
                           Etes-vous sûr de vouloir effacer le cours {this.state.title_lesson} ?
                        </p>
                                              
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:false});}}>Annuler</Button>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{
                              ev.preventDefault();this.setState({isOpenDelete:false});
                              
                              var xhr = new XMLHttpRequest();
                              xhr.overrideMimeType("application/json");
                              var that=this;
                              xhr.open('GET','/api/public/delcours?id_cours='+this.props.id_cours)
                              
                              xhr.setRequestHeader("Content-Type", "application/json");

                              //send the form data
                              xhr.send();

                                    xhr.onreadystatechange = function() {
                                        if (xhr.readyState == XMLHttpRequest.DONE) {
                                                      
                                        if(xhr.status==200) 
                                        { 
                                        
                                          //console.log(xhr.responseText);
                                          that.props.onchildrenevent();
                                          return;
                                          var jsonResponse = JSON.parse(xhr.responseText);
                                          console.log(jsonResponse);
                                          
                                          
                                          
                                        }
                                        if(xhr.status==404) {console.log( {message:"erreur"}); }
                                        if(xhr.status==500) {console.log( {message:"erreur"}); }
                                        
                                        }
                                      
                                    }
                              
                              
                              
                              
                              }} style={{ margin: "" }}>
                                Valider
                            </Button>
                            
                            
                        </div>
                    </div>
                </Overlay>
      <Overlay isOpen={this.state.isOpenEdit} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H4>Edition du cours</H4>
                        <input type="text" onChange={(ev)=>{this.setState({mustchange:true});this.setState({title_lesson:ev.target.value})}} value={this.state.title_lesson}/>
                        <p style={{marginTop:20}}>
                           Donnez une description à votre cours
                        </p>
                        <input type="text" onChange={(ev)=>{this.setState({mustchange:true});this.setState({lesson_description:ev.target.value})}} value={this.state.lesson_description} placeholder="Description"/>
                       
                       
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenEdit:false});}}>Annuler</Button>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{
                              ev.preventDefault();this.setState({isOpenEdit:false});
                              var droitpublication=[];
                              var stpublication="";
                              droitpublication = JSON.parse(localStorage.getItem('droitpublication'+this.props.id_cours));
                              if(droitpublication==null){droitpublication=[];stpublication=""}
                              else droitpublication=droitpublication.droitpublication;
                              droitpublication.map((it)=>{if (it.selected){
                                stpublication+=it.ID+"_";
                              }});
                              var xhr = new XMLHttpRequest();
                              xhr.overrideMimeType("application/json");
                              var formData = new FormData();
                              formData.append('Model.ID', this.props.id_cours);
                              formData.append('nom', this.state.title_lesson);
                              formData.append('id_matiere', this.props.matiere_id);
                              formData.append('description', this.state.lesson_description);
                              formData.append('tag', this.props.id_cours);
                              formData.append('publication', stpublication);

                              xhr.open('POST','/api/public/updatecours')
                              
                              xhr.setRequestHeader("Content-Type", "application/json");

                              //send the form data
                              xhr.send(JSON.stringify(Object.fromEntries(formData)));

                                    xhr.onreadystatechange = function() {
                                        if (xhr.readyState == XMLHttpRequest.DONE) {
                                                      
                                        if(xhr.status==200) 
                                        { 
                                        
                                          //console.log(xhr.responseText);
                                         
                                          return;
                                          var jsonResponse = JSON.parse(xhr.responseText);
                                          console.log(jsonResponse);
                                          
                                          
                                          
                                        }
                                        if(xhr.status==404) {console.log( {message:"erreur"}); }
                                        if(xhr.status==500) {console.log( {message:"erreur"}); }
                                        
                                        }
                                      
                                    }
                              
                              
                              
                              
                              }} style={{ margin: "" }}>
                                Valider
                            </Button>
                            
                            
                        </div>
                    </div>
      </Overlay>
      <Overlay isOpen={this.state.edit_published } className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H4>Choix des étudiants pour travailler avec ce cours</H4>
                        {/*<Switch checked={this.getcheckPublication(0)} label={this.getNomPublication(0)} onChange={(ev)=>this.handlePublicChange(this.state.droitpublication.filter((it)=>it.ID==0)[0])} />*/}
                        {this.state.droitpublication.map((itemclasse)=>{
                          
                          return(<Switch checked={this.getcheckPublication(itemclasse.ID)} label={this.getNomPublication(itemclasse.ID)} onChange={(ev)=>this.handlePublicChange(this.state.droitpublication.filter((it)=>it.ID==itemclasse.ID)[0])} />)
                          
                        })}
                       
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({edit_published:false});}}>Fermer</Button>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{
                              ev.preventDefault();this.setState({edit_published:false});
                              var droitpublication=[];
                              var stpublication="";
                              droitpublication = JSON.parse(localStorage.getItem('droitpublication'+this.props.id_cours));
                              if(droitpublication==null){droitpublication=[];stpublication=""}
                              else droitpublication=droitpublication.droitpublication;
                              droitpublication.map((it)=>{if (it.selected){
                                stpublication+=it.ID+"_";
                              }});
                              var xhr = new XMLHttpRequest();
                              xhr.overrideMimeType("application/json");
                              var formData = new FormData();
                              formData.append('Model.ID', this.props.id_cours);
                              formData.append('nom', this.state.title_lesson);
                              formData.append('id_matiere', this.props.matiere_id);
                              formData.append('description', this.state.lesson_description);
                              formData.append('tag', this.props.id_cours);
                              formData.append('publication', stpublication);

                              xhr.open('POST','/api/public/updatecours')
                              
                              xhr.setRequestHeader("Content-Type", "application/json");

                              //send the form data
                              xhr.send(JSON.stringify(Object.fromEntries(formData)));

                                    xhr.onreadystatechange = function() {
                                        if (xhr.readyState == XMLHttpRequest.DONE) {
                                                      
                                        if(xhr.status==200) 
                                        { 
                                        
                                          //console.log(xhr.responseText);
                                         
                                          return;
                                          var jsonResponse = JSON.parse(xhr.responseText);
                                          console.log(jsonResponse);
                                          
                                          
                                          
                                        }
                                        if(xhr.status==404) {console.log( {message:"erreur"}); }
                                        if(xhr.status==500) {console.log( {message:"erreur"}); }
                                        
                                        }
                                      
                                    }
                              
                              
                              
                                                                 
                              
                              }} style={{ margin: "" }}>
                                Sauvegarder
                            </Button>
                            
                            
                        </div>
                    </div>
      </Overlay>
        
      </Card>
      <div style={{display:this.state.isDocOpen, flexWrap: 'wrap', flex:'100%',width:'100%',backgroundColor:"rgba(245,245,245,0.9"}}>
      <div style={{display:'flex', flexWrap: 'wrap', flex:'100%'}}>
         {this.state.datadocuments.map(p => this.renderItem(p))}
      </div>
      </div>
      </div>
)
}
}
